import {MeshBuilder} from '@babylonjs/core/Meshes/meshBuilder.js';
import {TransformNode} from '@babylonjs/core/Meshes/transformNode.js';
import {StandardMaterial} from '@babylonjs/core/Materials/standardMaterial.js';
import {Color3} from '@babylonjs/core/Maths/math.color.js';
import {Scene} from '@babylonjs/core/scene.js';
import {Vector3} from '@babylonjs/core/Maths/math.vector.js';
import {Input} from './input';
import {move,height} from './world';
export class Character {
 root:TransformNode; private visual:TransformNode;private limbs:TransformNode[]=[];private time=0;
 state='idle';speed=0;
 constructor(scene:Scene){
  this.root=new TransformNode('player',scene);this.root.position.set(0,0,-11);
  this.visual=new TransformNode('replaceable-character-visual',scene);this.visual.parent=this.root;
  const cloth=new StandardMaterial('placeholder-cloth',scene);cloth.diffuseColor=Color3.FromHexString('#425e72');
  const skin=new StandardMaterial('placeholder-head',scene);skin.diffuseColor=Color3.FromHexString('#c6b28d');
  const part=(name:string,w:number,h:number,d:number,x:number,y:number,z:number,parent:TransformNode,mat=cloth)=>{
   const mesh=MeshBuilder.CreateBox(name,{width:w,height:h,depth:d},scene);mesh.position.set(x,y,z);mesh.parent=parent;mesh.material=mat;mesh.isPickable=false;return mesh;
  };
  part('torso',.6,.65,.32,0,1.12,0,this.visual);
  const head=MeshBuilder.CreateSphere('head',{diameter:.38,segments:12},scene);head.position.y=1.66;head.parent=this.visual;head.material=skin;head.isPickable=false;
  part('face-direction',.14,.08,.05,0,1.65,.19,this.visual);
  for(const [x,y,h] of [[-.17,.8,.8],[.17,.8,.8],[-.43,1.4,.6],[.43,1.4,.6]]){
   const pivot=new TransformNode('limb-pivot',scene);pivot.position.set(x,y,0);pivot.parent=this.visual;
   part('limb',.18,h,.2,0,-h/2,0,pivot);this.limbs.push(pivot);
  }
 }
 update(dt:number,input:Input,yaw:number) {
  const d=input.direction();const magnitude=Math.hypot(d.x,d.y);this.speed=(d.run?5.5:2.5)*magnitude*d.speedScale;
  this.state=magnitude<.05?'idle':d.run?'run':'walk';
  if(magnitude>=.05){
   const dx=(Math.cos(yaw)*d.x+Math.sin(yaw)*d.y)*this.speed*dt/magnitude;
   const dz=(-Math.sin(yaw)*d.x+Math.cos(yaw)*d.y)*this.speed*dt/magnitude;
   const next=move(this.root.position.x,this.root.position.z,dx,dz);
   this.root.position.x=next.x;this.root.position.z=next.z;
   const target=Math.atan2(dx,dz), delta=Math.atan2(Math.sin(target-this.root.rotation.y),Math.cos(target-this.root.rotation.y));
   this.root.rotation.y+=delta*(1-Math.exp(-14*dt));
  }
  this.root.position.y=height(this.root.position.x,this.root.position.z);
  this.time+=dt;const active=this.state!=='idle';const phase=this.time*(d.run?12:7);
  this.limbs.forEach((p,i)=>p.rotation.x=active?Math.sin(phase+(i%2)*Math.PI)*(i<2?.65:.5):Math.sin(this.time*2)*.025);
  this.visual.position.y=active?Math.abs(Math.sin(phase))*.045:Math.sin(this.time*2)*.012;
 }
 get target(){return this.root.position.add(new Vector3(0,1.35,0));}
}
